
import React, { useEffect, useState } from 'react'

import useTranslation from '../../Hooks/UseTranslation';

import ToggleGroupIcon from '../AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon';
import Check from '../SvgImages/Check';

import './KanbanTaskWorksList.scss'

interface Props {
  works: any[];
  onSelectWork: (work_id: string) => void;
}

const KanbanTaskWorksList = ({ works, onSelectWork }: Props) => {

  const { t } = useTranslation();

  const [ isOpen, setIsOpen ] = useState(true)

  const [ restrictions, setRestrictions ] = useState('')

  const getAllRestrictions = (): any => {

    let checked = 0
    let all = 0

    works.forEach((work: any) => {

      if (work.restrictions.length) {

        all += work.restrictions.length

        work.restrictions.forEach((restriction: any) => {

          if (restriction.checked) {

            checked += 1
          }
        })
      }
    })

    if (all === 0) {

      return ''
    }

    return `${checked}/${all}`
  }

  const getWorkRestrictions = (work: any) => {

    let checked = 0
    let all = 0

    work.restrictions.forEach((restriction: any) => {

      if (restriction.checked) {

        checked += 1
      }
      all += 1
    })

    if (all === 0) {

      return null
    }

    return (
      <span className={`restrictions ${checked === all ? 'all-closed' : 'still-open'}`}>
        {`(${checked}/${all})`}
      </span>
    )
  }

  useEffect(() => {

    setRestrictions(getAllRestrictions())
  }, [ works ])

  return (
    <div className="kanban-task-works-list">
      <div className="header"
        onClick={(e: any) => {
          e.stopPropagation()
          e.preventDefault()

          setIsOpen(!isOpen)
        }}
      >
        <div className="title">
          {t('TASK_CARD:Works')} ({works.length})
        </div>
        <div className="contraints">
          {restrictions && (
            <>
              {t('TASK_CARD:Constraints')} ({restrictions})
            </>
          )}
        </div>
        <div className="toggle-button">
          <ToggleGroupIcon isOpen={isOpen} size={16} />
        </div>
      </div>
      <div className={`body ${isOpen ? '' : 'collapsed'}`}
        style={{ height: isOpen ? (works.length * 23) : 0 }}
      >
        {works.map((work: any) => (
          <div key={work._id}
            className="work-item"
            onClick={(e: any) => {
              e.stopPropagation()
              e.preventDefault()

              onSelectWork(work._id)
            }}
          >
            {work.colorCode && (
              <div className="color-code" style={{ backgroundColor: work.colorCode.color }}></div>
            )}
            <div className="name"
              style={{
                color: work.status === 'completada' ? '#9fa1a0' : '#000',
              }}
            >
              {work.name}
            </div>
            <div className="constraints">
              {getWorkRestrictions(work)}
            </div>
            <div style={{ marginLeft: '.5rem', paddingBottom: 2, width: 20 }}>
              {work.status === 'completada' && (
                <Check width={18} height={18} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default KanbanTaskWorksList